import { useFormContext } from '@sravni/cosago-react-library/lib/hooks';
import { useEffect } from 'react';

import { iso8601DurationToDays, iso8601DurationToMonths, useAppDispatch } from 'shared/lib';
import { pluralizeDays, pluralizeMonths } from 'shared/lib/pluralize';

import { setMfoInfo } from 'entities/mfo/model/mfoForm.slice';

import { PERIOD } from '../MfoFullDealForm.constants';

const { days, months } = PERIOD;

export const usePeriodInfo = () => {
  const { watch, setValue } = useFormContext();
  const dispatch = useAppDispatch();
  const value = watch('period');
  const amountValue = watch('amount');

  const isDaysPeriods = amountValue < 100000;

  const minPeriod = isDaysPeriods ? days.min : months.min;
  const maxPeriod = isDaysPeriods ? days.max : months.max;

  const duration = isDaysPeriods ? 'дней' : 'месяцев';
  const postfix = isDaysPeriods
    ? pluralizeDays(iso8601DurationToDays(value))
    : pluralizeMonths(iso8601DurationToMonths(value));

  useEffect(() => {
    const period = isDaysPeriods ? 60 : 12;

    setValue('period', period);
    dispatch(setMfoInfo({ period }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isDaysPeriods]);

  return {
    minPeriod,
    maxPeriod,
    duration,
    postfix,
  };
};
